export default function ExportButtons({
  exportCSV,
  exportExcel,
  handlePrint,
  exportPDF,
  downloading = null,
}) {
  return (
    <div className="export-section">
      <button
        className="btn-export"
        onClick={exportCSV}
        disabled={downloading === "csv"}
      >
        <i className="fas fa-file-csv" />
        {downloading === "csv" ? " generating..." : "Export Csv"}
      </button>

      <button
        className="btn-export"
        onClick={exportExcel}
        disabled={downloading === "excel"}
      >
        <i className="fas fa-file-excel" />{" "}
        {downloading === "excel" ? " generating..." : "Export Excel"}
      </button>

      <button className="btn-export" onClick={handlePrint}>
        <i className="fas fa-print" /> Print
      </button>

      <button
        className="btn-export btn-pdf"
        onClick={exportPDF}
        disabled={downloading === "pdf"}
      >
        <i className="fas fa-file-pdf" />
        {downloading === "pdf" ? " generating..." : "pdf"}
      </button>
    </div>
  );
}
